import { graphql } from "msw";
import { mockCart, mockCartOrderSummary } from "./mockCart";
import {
  RemoveGiftCardFromCartMutationVariables,
  RemoveGiftCardFromCartMutation,
} from "@cart-app/generated/graphql";

export const handler = graphql.mutation<
  RemoveGiftCardFromCartMutation,
  RemoveGiftCardFromCartMutationVariables
>("RemoveGiftCardFromCart", (req, res, ctx) => {
  const codeToRemove = req.variables.giftCardCode;
  const cardToRemove = mockCartOrderSummary.giftCards?.find(
    (card) => card.code === codeToRemove
  );
  const cardsToKeep = mockCartOrderSummary.giftCards?.filter(
    (card) => card.code !== codeToRemove
  );

  const newTotal =
    mockCartOrderSummary.totalPrice.amount +
    (cardToRemove?.appliedBalance.amount || 0);

  return res(
    ctx.data({
      removeGiftCardFromCart: {
        __typename: "Cart" as const,
        ...mockCart,
        orderSummary: {
          ...mockCartOrderSummary,
          giftCards: cardsToKeep && cardsToKeep.length > 0 ? cardsToKeep : [],
          totalPrice: { __typename: "Money" as const, amount: newTotal },
        },
      },
    })
  );
});
